import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Menubar from "../Shared/Header/Menubar/Menubar";
import "./Details.css";
const Details = () => {
  const { projectId } = useParams();
  const [details, setDetails] = useState([]);
  // getting all projects
  useEffect(() => {
    fetch("/projects.json")
      .then((res) => res.json())
      .then((data) => setDetails(data));
  }, []);
  console.log(details);
  const projectDetail = details.find((detail) => detail.id === projectId);
  return (
    <>
      <Menubar />
      <div className="detail-container" key={projectDetail?.id}>
        <div className="details mt-5">
          <div className="details-img container mx-auto  ">
            <img className="detail-img pe-2" src={projectDetail?.img1} alt="" />
            <img className="detail-img pe-2" src={projectDetail?.img2} alt="" />
            <img className="detail-img pe-2" src={projectDetail?.img3} alt="" />
          </div>
          <p className="detail-p mt-2"></p>
          <div className="detail-body-container">
            <div className="detail-body  text-white ">
              <p className="fs-5 fw-bold"><span className="detail-p fw-bold fs-6">Project Name: </span> { projectDetail?.name}</p>
              <p><span className="detail-p fw-bold"> Project Type:  </span> { projectDetail?.projectType}</p>
              <p><span className="detail-p fw-bold">Category: </span> {projectDetail?.category}</p>
              <p>
               <span className="mb-3 detail-p fw-bold"> Technologies: </span><br />
                <p className="btn detail-btn mt-2 ms-5">{ projectDetail?.tech1}</p>
                <p className="btn detail-btn mt-2">{projectDetail?.tech2}</p>
                <p className="btn detail-btn mt-2">{projectDetail?.tech3}</p>
                <p className="btn detail-btn mt-2">{projectDetail?.tech4}</p>
                <p className="btn detail-btn mt-2">{projectDetail?.tech5}</p>
                <p className="btn detail-btn mt-2">{projectDetail?.tech6}</p>
                <p className="btn detail-btn mt-2">{projectDetail?.tech7}</p>
                <p className="btn detail-btn">{projectDetail?.tech8}</p>
                <p className="btn detail-btn">{projectDetail?.tech9}</p>
              </p>
              <p className="mt-2 text-white"><span className="detail-p fw-bold">Project Overview: </span>
              <p className="ms-5 ps-5">{projectDetail?.pO1}</p>
              <p className="ms-5 ps-5">{projectDetail?.pO2}</p>
              <p className="ms-5 ps-5">{projectDetail?.pO3}</p>
              <p className="ms-5 ps-5">{projectDetail?.pO4}</p>
              <p className="ms-5 ps-5">{projectDetail?.pO5}</p></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Details;
